import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show CTA after scrolling past the hero section (approx 600px)
      const heroHeight = document.getElementById('hero')?.offsetHeight || 600;
      const scrollPosition = window.scrollY;
      // Hide near the bottom to not overlap footer too much
      const isNearBottom = window.innerHeight + scrollPosition >= document.body.offsetHeight - 400;
      if (scrollPosition > heroHeight && !isNearBottom) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    // Initial check
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-118">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-cream border-t border-cream-dark shadow-[0_-10px_40px_rgba(44,51,51,0.05)]" data-id="element-119">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-120">
            <div className="hidden sm:block" data-id="element-121">
              <p className="font-serif text-lg font-medium text-teal" data-id="element-122">
                The 7-Day Cortisol Reset
              </p>
              <p className="text-xs text-teal-muted uppercase tracking-wider" data-id="element-123">
                Instant Digital Access
              </p>
            </div>
            <button className="w-full sm:w-auto inline-flex justify-center items-center px-8 py-3 text-sm font-medium text-white bg-sage hover:bg-sage-hover transition-colors duration-200 rounded-none shadow-sm" data-id="element-124">
              Start the 7-Day Reset ($6.36)
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}